<template>
  <div class="container" v-bind:class="{ triple: imgTarjetas.length > 2 }">
    <div
      class="img-container"
      v-for="imgsrc in imgTarjetas"
      v-bind:key="imgsrc"
    >
      <img :src="imgsrc" alt="BBVA" />
      <svg viewBox="0 0 290 18" class="custom-name">
        <text :data-obfuscate="quantumObfuscate" x="0" y="13">
          {{ nombreCliente }}
        </text>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductImageContainer",
  props: {
    tarjetas: {
      type: Array,
      default: function() {
        return [];
      }
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  computed: {
    imgTarjetas() {
      return this.tarjetas.map(codigo => {
        return require(`@/assets/img/ofertaNomina/tarjetas/${codigo}.png`);
      });
    },
    nombreCliente() {
      let { nombre, apellido } = this.$store.state.consulta;
      let nombres = nombre.split(" ");
      let apellidos = apellido.split(" ");

      return `${nombres[0].slice(0, 12)} ${apellidos[0].slice(0, 12)}`;
    }
  }
};
</script>

<style scoped>
img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
}

.img-container {
  width: 48%;
  position: relative;
  z-index: 1;
}

.custom-name {
  position: absolute;
  left: 4.2%;
  width: 100%;
  bottom: 4%;
  z-index: 1000;
  text-transform: uppercase;
}

.custom-name text {
  fill: white;
  text-shadow: 1px 1px rgba(0, 0, 0, 0.48);
  font-family: monospace;
}

.container {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.container.triple {
  justify-content: flex-end;
  padding-top: 10%;
}

.container.triple .img-container {
  width: 44%;
}

.container.triple .img-container:first-child {
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
}

.container.triple .img-container:nth-child(2) {
  margin-right: 4%;
}

@media screen and (max-width: 1024px) {
  .img-container {
    margin-left: auto;
    margin-right: auto;
    width: 215px;
  }
}
</style>
